import React from 'react';
import { useIntl } from 'react-intl'

// @ts-ignore - no typing info for YML files
import carrierData from 'resources/carriers.yml';

import { useTrackingData, TrackingStatusCodes, TrackingEvent, useShipmentData, Carrier } from '../dataProviders';
import { isGiftWrapped } from './GiftWrapPanel';


function useFriendlyMessageFromStatus({ source, status_code, estimated_delivery_date, events=[] }:{
  source?: string,
  status_code?: TrackingStatusCodes,
  estimated_delivery_date?: string | null,
  events?: Array<TrackingEvent>
}, carrier_code: Carrier ) {
  const intl = useIntl();

  if( !source || source.toLowerCase() !== 'shipengine' ) {
    return null;
  }

  const IN_TRANSIT_MSG = (isGiftWrapped) ? (
    intl.formatMessage({
      description: 'friendlyStatusMessage.inTransitAsGift',
      defaultMessage: 'Your gift is on its way.'
    })
  ):(
    intl.formatMessage({
      description: 'friendlyStatusMessage.inTransit',
      defaultMessage: 'Your shipment is on its way.'
    })
  );

  switch( (status_code || '').toUpperCase() ) {
    case 'AC':
      return intl.formatMessage({
        description: 'friendlyStatusMessage.accepted',
        defaultMessage: 'Tracking details will be available once package arrives at the shipping facility.'
      });
    case 'IT':
      return IN_TRANSIT_MSG;
    case 'DE':
      return intl.formatMessage({
        description: 'friendlyStatusMessage.delivered',
        defaultMessage: 'Your shipment has been delivered.'
      });
    case 'EX':
      return intl.formatMessage({
        description: 'friendlyStatusMessage.exception',
        defaultMessage: 'Your shipment status is unavailable. Check back later.'
      });
    case 'UN':
      if( estimated_delivery_date || events.length ) {
        return IN_TRANSIT_MSG;
      }
      else {
        return intl.formatMessage({
          description: 'friendlyStatusMessage.unknown',
          defaultMessage: 'Your shipment status is unknown. Check back later.'
        });
      }
    case 'AT': {
      const carrierName = carrierData[carrier_code]?.name || 'the carrier';
      return intl.formatMessage({
        description: 'friendlyStatusMessage.attemptedDelivery',
        defaultMessage: 'Contact {carrierName} for information on the attempted delivery.',
      }, { carrierName });
    }
    default:
      return intl.formatMessage({
        description: 'friendlyStatusMessage.fallbackDefault',
        defaultMessage: 'Tracking details will be available once package arrives at the shipping facility.'
      });
  }
}


export default function FriendlyStatusMessage({ className='' }) {
  const trackingData = useTrackingData();
  const { carrier_code } = useShipmentData();

  const message = useFriendlyMessageFromStatus( trackingData, carrier_code );

  if( !message ) {
    return null;
  }

  return <span className={className}>
    {message}
  </span>;
}
